import React, { createRef, Component } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import schedule from '@insight/toolkit-utils/lib/timing/schedule'

import { setRef } from '../utils'

export default class Popover extends Component {
	popover = createRef()

	componentDidMount() {
		this.updateDimensions()
		window.addEventListener('resize', this.updateDimensions)
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateDimensions)
	}

	updateDimensions = schedule(() => {
		if (this.popover) {
			this.props.positionTooltip(this.popover.current.getBoundingClientRect())
		}
	})

	setPopoverRef = node => {
		setRef(this.popover, node)
		if (this.props.popoverRef) {
			this.props.popoverRef(node)
		}
	}

	render() {
		const {
			children,
			className,
			popoverRef,
			positionTooltip,
			title,
			...rest
		} = this.props

		const classes = cn(this.props.isInModal ? 'c-tooltip__popover--modal' : 'c-tooltip__popover', className)
		const optionalTitle = title && (
			<span className="c-tooltip__title">{title}</span>
		)

		return (
			<div className={classes} ref={this.setPopoverRef} {...rest}>
				{optionalTitle}
				{children}
			</div>
		)
	}
}
